import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employer-edit-profile',
  templateUrl: './employer-edit-profile.component.html',
  styleUrls: ['./employer-edit-profile.component.css']
})
export class EmployerEditProfileComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
